<script setup>
import BoundedComponent from '@/components/BoundedComponent.vue';
import VideoPlayRandom from '@/components/VideoPlayRandom.vue';

import LogoJSON from '@/lotties/logo.json';
import { Vue3Lottie } from 'vue3-lottie';

const heroText = {
  header: 'Hvað er Líttupp?',
  p: 'Líttupp er vitundarvakning sem hvetur okkur öll - börn, ungmenni og fullorðna - til að staldra við, líta upp úr skjánum og taka virkari þátt í lífinu í kringum okkur. Með Líttupp viljum við skapa samtal um heilbrigðari og ábyrgari tækjanotkun, jákvæð samskipti og kosti þess að vera meira til staðar í raunheimum.',
};
</script>

<template>
  <!-- ToDo: improve max height, add video as bg to the next section -->
  <header
    class="mx-auto w-full min-h-[810px] relative flex mt-auto mb-12 lg:mb-29 justify-center select-none"
  >
    <!-- video -->
    <div class="min-h-[600px] overflow-hidden">
      <VideoPlayRandom />
    </div>
    <!-- hero text -->
    <BoundedComponent
      className="min-h-[810px]"
      childClassName="flex flex-col justify-between h-full pt-17.5 lg:pt-32"
    >
      <div
        v-fade-up="{ delay: 0.2 }"
        class="flex gap-5 md:gap-8 lg:gap-11 self-center items-center lg:mt-auto lg:mb-5"
      >
        <Vue3Lottie
          class="logo-responsive"
          :animationData="LogoJSON"
          :width="120"
          :height="105"
          role="img"
          aria-label="lógó"
        />
        <div
          class="text-5xl font-medium text-yellow block lg:text-6xl md:font-semibold max-w-47 sm:max-w-54 md:max-w-max"
        >
          {{ heroText.header }}
        </div>
      </div>
      <h1
        v-fade-up="{ delay: 0.4 }"
        class="text-white text-center max-w-4xl mx-auto -mb-2 lg:-mb-10"
      >
        {{ heroText.p }}
      </h1>
    </BoundedComponent>
  </header>
</template>

<style scoped>
.logo-responsive {
  width: 120px;
  height: 105px;
}
@media (min-width: 768px) {
  .logo-responsive {
    width: 191px;
    height: 168px;
  }
}
</style>
